import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

export const env = createEnv({
  clientPrefix: "NEXT_PUBLIC_",
  server: {
    CLOUDFLARE_ZONE_ID: z.string().optional(),
    CLOUDFLARE_CACHE_PURGE_TOKEN: z.string().optional(),
    DATABASE_URL: z.string().url(),
    DATABASE_SESSION_MODE_URL: z.string().url(),
    NODE_ENV: z
      .enum(["development", "test", "production"])
      .default("development"),
    SUPABASE_PUBLIC_URL: z.string().url(),
    SUPABASE_PUBLIC_ANON_KEY: z.string(),
    SUPABASE_SECRET_KEY: z.string(),
    OPEN_AI_SECRET_KEY: z.string(),
    EP_ONLINE_API_KEY: z.string().optional(),
    GEOAPIFY_API_KEY: z.string(),
    GOOGLE_AI_API_KEY: z.string(),
    SEVALLA_ACCESS_KEY: z.string(),
    SEVALLA_SECRET_KEY: z.string(),
    FREE_CURRENCY_API_KEY: z.string(),
    FIREWORKS_API_KEY: z.string(),
    BROWSERBASE_API_KEY: z.string(),
    BROWSERBASE_PROJECT_ID: z.string(),
    CLERK_SECRET_KEY: z.string(),
    CLERK_WEBHOOK_SECRET: z.string(),
    STRIPE_WEBHOOK_SECRET: z.string(),
    STRIPE_SECRET_KEY: z.string(),
    STRIPE_TEST_SECRET_KEY: z.string().optional(),
    STRIPE_TEST_WEBHOOK_SECRET: z.string().optional(),
    RESEND_API_KEY: z.string(),
    KV_URL: z.string(),
    KV_REST_API_URL: z.string(),
    KV_REST_API_TOKEN: z.string(),
    KV_REST_API_READ_ONLY_TOKEN: z.string(),
    REDIS_URL: z.string(),
    LEMONADE_ADS_ENABLED: z
      .enum(["true", "false"])
      .default("false")
      .transform((value) => value === "true"),
  },
  client: {
    NEXT_PUBLIC_URL: z.string().default("http://localhost:4099"),
    NEXT_PUBLIC_POSTHOG_KEY: z.string(),
    NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY: z.string(),
    NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY: z.string(),
  },
  runtimeEnv: {
    CLOUDFLARE_ZONE_ID: process.env.CLOUDFLARE_ZONE_ID,
    CLOUDFLARE_CACHE_PURGE_TOKEN: process.env.CLOUDFLARE_CACHE_PURGE_TOKEN,
    NODE_ENV: process.env.NODE_ENV,
    NEXT_PUBLIC_URL: process.env.NEXT_PUBLIC_URL,
    DATABASE_URL: process.env.DATABASE_URL,
    DATABASE_SESSION_MODE_URL: process.env.DATABASE_SESSION_MODE_URL,
    SUPABASE_PUBLIC_URL: process.env.SUPABASE_PUBLIC_URL,
    SUPABASE_PUBLIC_ANON_KEY: process.env.SUPABASE_PUBLIC_ANON_KEY,
    SUPABASE_SECRET_KEY: process.env.SUPABASE_SECRET_KEY,
    OPEN_AI_SECRET_KEY: process.env.OPEN_AI_SECRET_KEY,
    EP_ONLINE_API_KEY: process.env.EP_ONLINE_API_KEY,
    GEOAPIFY_API_KEY: process.env.GEOAPIFY_API_KEY,
    GOOGLE_AI_API_KEY: process.env.GOOGLE_AI_API_KEY,
    NEXT_PUBLIC_POSTHOG_KEY: process.env.NEXT_PUBLIC_POSTHOG_KEY,
    SEVALLA_ACCESS_KEY: process.env.SEVALLA_ACCESS_KEY,
    SEVALLA_SECRET_KEY: process.env.SEVALLA_SECRET_KEY,
    FREE_CURRENCY_API_KEY: process.env.FREE_CURRENCY_API_KEY,
    FIREWORKS_API_KEY: process.env.FIREWORKS_API_KEY,
    BROWSERBASE_API_KEY: process.env.BROWSERBASE_API_KEY,
    BROWSERBASE_PROJECT_ID: process.env.BROWSERBASE_PROJECT_ID,
    CLERK_SECRET_KEY: process.env.CLERK_SECRET_KEY,
    NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY:
      process.env.NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY,
    CLERK_WEBHOOK_SECRET: process.env.CLERK_WEBHOOK_SECRET,
    STRIPE_WEBHOOK_SECRET: process.env.STRIPE_WEBHOOK_SECRET,
    STRIPE_SECRET_KEY: process.env.STRIPE_SECRET_KEY,
    STRIPE_TEST_SECRET_KEY: process.env.STRIPE_TEST_SECRET_KEY,
    STRIPE_TEST_WEBHOOK_SECRET: process.env.STRIPE_TEST_WEBHOOK_SECRET,
    NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY:
      process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY,
    RESEND_API_KEY: process.env.RESEND_API_KEY,
    KV_URL: process.env.KV_URL,
    KV_REST_API_URL: process.env.KV_REST_API_URL,
    KV_REST_API_TOKEN: process.env.KV_REST_API_TOKEN,
    KV_REST_API_READ_ONLY_TOKEN: process.env.KV_REST_API_READ_ONLY_TOKEN,
    REDIS_URL: process.env.REDIS_URL,
    LEMONADE_ADS_ENABLED: process.env.LEMONADE_ADS_ENABLED,
  },
});
